export default class Utils{
    public static isUserCrawler(){
        return /bot|googlebot|crawler|spider|robot|crawling|lighthouse/i.test(navigator.userAgent);
    }
}
